/**
 * Brand constants for the application
 */
export const PROJECT_NAME = "Karma";
